import React from 'react';
import Tooltip from '@atlaskit/tooltip';
export var ToolbarTooltip = function ToolbarTooltip(_ref) {
  var content = _ref.content,
    children = _ref.children,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'top' : _ref$position,
    delay = _ref.delay;
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: content,
    position: position,
    delay: delay
  }, children);
};